import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseRefuseQuoteResult = {
  refuseQuote: (id: string) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useRefuseQuote(): UseRefuseQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const refuseQuote = async (id: string): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const quote = await HttpClient.post<Quote>(QUOTES_API_PATHS.REFUSE(id), {});

      enqueueSnackbar('Devis refusé', { variant: 'success' });
      return quote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors du refus du devis'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { refuseQuote, isSubmitting };
}
